require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./knowledgeresources-the-stockdale-paradox.json") })
        }
      }, "path---knowledgeresources-the-stockdale-paradox");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---knowledgeresources-the-stockdale-paradox!./.cache/json/knowledgeresources-the-stockdale-paradox.json
// module id = 1161
// module chunks = 231608221292675